var _style, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeooIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 74.5 73.1",
    style: {
      enableBackground: "new 0 0 74.5 73.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 36.6,
    r: 36.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 36.2,
    cy: 37,
    r: 6.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.7,20.7C58.4,15,49.4,11.6,43.3,16c-3.8-1.3-7.7-1.5-11.8-0.6c-6,1.3-10.6,4.6-13.9,9.8 c-3.3,5.2-4.2,10.7-2.9,16.7c1.3,6,4.6,10.6,9.8,13.9c5.2,3.3,10.7,4.2,16.7,2.9c6-1.3,10.6-4.6,13.9-9.8 c3.3-5.2,4.2-10.7,2.9-16.7c-0.8-3.6-2.4-6.8-4.6-9.4c1.9-1.5,4.4-2.1,7.1-1.7c0.1,0,0.2,0,0.4,0.1C60.8,21,60.8,20.8,60.7,20.7z  M48.7,45c-2.1,3.4-5.2,5.6-9.2,6.5c-4,0.9-7.7,0.3-11.1-1.9c-3.4-2.2-5.5-5.2-6.4-9.2c-0.9-4-0.3-7.7,1.9-11.1 c2.2-3.4,5.2-5.6,9.2-6.5c4-0.9,7.6-0.2,11,1.9c3.4,2.2,5.6,5.2,6.5,9.2C51.5,37.9,50.9,41.6,48.7,45z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeooIconBlack);
export default __webpack_public_path__ + "static/media/Neoo_icon_black.c9c2f8bcda096bf74f0fa400b235bfed.svg";
export { ForwardRef as ReactComponent };